/** Split-circle mark. Left #57565C, right #3E3D42. */
export function ChLogo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <path fill="#57565C" d="M16 0A16 16 0 0 0 16 32Z" />
      <path fill="#3E3D42" d="M16 0A16 16 0 0 1 16 32Z" />
    </svg>
  );
}
